import React from 'react';
import { css } from 'aphrodite/no-important';
import { useIntl } from 'react-intl';

import messages from './messages';
import styles from './styles';

interface Props {
  corporateName: string;
  corporateReference: string;
  clientReference?: string;
}

const CorporateInfo: React.FC<Props> = ({ corporateName, corporateReference, clientReference }) => {
  const { formatMessage } = useIntl();

  return (
    <div className={css(styles.container)}>
      <h3>{corporateName}</h3>
      <p>{`${formatMessage(messages.corporateReference)}: ${corporateReference}`}</p>
      {clientReference && <p>{`${formatMessage(messages.clientReference)}: ${clientReference}`}</p>}
    </div>
  );
};

export default CorporateInfo;
